import React from 'react'

import { getIdentity } from '../../hooks/useParticipants/useParticipants'
import useTrack from '../../hooks/useTrack/useTrack'
import VideoTrack from '../VideoTrack/VideoTrack'

export default function Publication({
    publication,
    participant,
    isLocal,
    videoPriority,
    id,
    isTeacher,
    lastIndex,
    enableScreenShare,
}) {
    const track = useTrack(publication, participant)

    if (!track) return null
    switch (track.kind) {
        case 'video':
            return (
                <>
                    <VideoTrack
                        track={track}
                        priority={videoPriority}
                        isLocal={track.name.includes('camera') && isLocal}
                        id={id}
                        isTeacher={isTeacher}
                        isTeacherIdentity={
                            getIdentity(participant.identity)?.isTeacher
                        }
                        lastIndex={lastIndex}
                        enableScreenShare={enableScreenShare}
                    />
                </>
            )

        default:
            return null
    }
}
